// extracted by mini-css-extract-plugin
export default {"container":"Bwv605","content":"skLDTj","left":"csVJIS","right":"CuiqJM","open":"WQPpj6","closing":"vp5v78"};